import { Component, OnInit } from '@angular/core';

// Service
import { ApiService } from '../../shared/service/api.service';
@Component({
  selector: 'app-investor',
  templateUrl: './investor.component.html',
  styles: [
  ]
})
export class InvestorComponent implements OnInit {

  dataBanner;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getDataApi('getSubHeaderByLink/investor').subscribe(response => {
        this.dataBanner = response.data;
    });
  }

}
